import { Table } from '@chakra-ui/react';
import { CustomFieldEntityEnum, IAccountRespSchema } from '@monetize/types/app';
import { Maybe } from '@monetize/types/common';
import { MText } from '../../../components/Monetize';
import { useCustomFields } from '../../../hooks/useCustomFields';
import { getCustomFieldDisplayValue } from '../../../utils/customFields';
import { ThData, TrData } from './AccountMergeRenderers';
import { AccountToKeep } from './AccountMergeTable.types';

export function CustomFieldTableRows({
  mainAccount,
  otherAccount,
  accountToKeep,
}: {
  mainAccount: IAccountRespSchema;
  otherAccount?: Maybe<IAccountRespSchema>;
  accountToKeep: AccountToKeep;
}) {
  const { customFieldList } = useCustomFields(CustomFieldEntityEnum.ACCOUNT);

  if (!customFieldList || customFieldList.length === 0) {
    return null;
  }

  return (
    <>
      <Table.Row _hover={{ bg: 'transparent' }}>
        <Table.ColumnHeader
          textTransform="none"
          fontWeight={500}
          letterSpacing="inherit"
          textAlign="right"
          width="200px"
          borderRight="1px solid {colors.tGray.back}"
        >
          <MText>Custom Fields</MText>
        </Table.ColumnHeader>
        <Table.Cell colSpan={2} />
      </Table.Row>
      {customFieldList.map((field) => (
        <Table.Row key={field.key} _hover={{ fontWeight: '600' }}>
          <ThData>{field.displayLabel}</ThData>
          <TrData
            cellStyle={accountToKeep === AccountToKeep.MAIN ? 'KEEP' : 'DELETE'}
            borderRight="1px solid {colors.tGray.back}"
          >
            {getCustomFieldDisplayValue(
              field.type,
              mainAccount.customFields[field.key],
            ) ?? null}
          </TrData>
          <TrData
            cellStyle={
              otherAccount
                ? accountToKeep === AccountToKeep.OTHER
                  ? 'KEEP'
                  : 'DELETE'
                : 'NONE'
            }
          >
            {otherAccount?.customFields
              ? (getCustomFieldDisplayValue(
                  field.type,
                  otherAccount.customFields[field.key],
                ) ?? null)
              : null}
          </TrData>
        </Table.Row>
      ))}
    </>
  );
}
